module.exports = __webpack_public_path__ + "static/img/General Advice.892c6ce.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/doctors/General Advice.svg
// module id = mS2t
// module chunks = 0